import { tv } from 'tailwind-variants';

const tailwindVariantProduct = tv({
  slots: {
    productListContainer: [
      'flex',
      'flex-col',
      'md:flex-row',
      'justify-between',
      'gap-components-card-search-result-spacing-large-image-margin-right',
    ],
    productCard: [
      'content-center',
      'px-spacing-padding-large-1',
      'py-components-card-search-result-spacing-large-padding-y',
    ],
    productTitle: [
      'items-center',
      'content-center',
      'w-full',
      'md:w-[45%]',
      'lg:w-[65%]',
      'font-header-large-xSmall',
      'leading-header-large-xSmall',
      'text-header-large-xSmall',
      'text-components-product-card-color-title',
    ],
    productListLabel: [
      'grid',
      'grid-cols-1',
      'md:grid-cols-2',
      'self-stretch',
      'content-start',
      'md:content-center',
      'gap-spacing-space-between-large-4',
    ],
    productSection: [
      'flex',
      'flex-col',
      'flex-wrap',
      'self-stretch',
      'content-start',
      'md:content-center',
      'gap-spacing-spacing-3',
    ],
    topSection: [
      'flex',
      'flex-col',
      'flex-wrap',
      'self-stretch',
      'content-center',
      'gap-spacing-spacing-3',
    ],
    productMainLabel: [
      '[&>a]:underline',
      '[&>a]:!cursor-pointer',
      'text-bodySans-medium-underline',
      'leading-bodySans-medium-underline',
      'font-bodySans-medium-underline',
      'md:text-bodySans-medium-underline',
      'md:font-bodySans-medium-underline',
      'md:leading-bodySans-medium-underline',
      'text-components-hyperlink-color-dark-default',
      'hover:text-components-hyperlink-color-dark-hover',
    ],
    productDates: [
      'text-bodySans-small',
      'font-bodySans-small',
      'leading-bodySans-small',
      'md:text-bodySans-small',
      'md:font-bodySans-small',
      'md:leading-bodySans-small',
      'text-themes-general-surface-color-light-body',
    ],
  },
});
export default tailwindVariantProduct;

export const tailwindVariantPagination = tv({
  slots: {
    base: ['flex'],
    paginationContainer: ['flex', 'flex-col', 'md:pt-spacing-spacing-7', 'pt-spacing-spacing-5'],
    paginationRoot: ['flex', 'justify-between', 'items-start'],
    paginationIcon: [
      'p-0',
      'min-h-auto',
      ['[&>button]:flex'],
      ['[&>button]:p-0'],
      ['[&>button]:min-h-min'],
      'font-bodySans-medium-semibold',
      'pt-components-button-spacing-compressed-default-padding-y',
      'pb-1.5',
      'rounded-themes-spacing-radius-large-button',
      'bg-components-button-color-text-brand-default-bg',
      'text-bodySans-medium-semibold',
      'leading-bodySans-medium-semibold',
      'text-components-button-color-outline-brand-default-text',
    ],
    paginationPageWrapper: [
      'md:flex',
      'flex-row',
      'gap-spacing-spacing-1',
      'hidden',
      '[&_span]:pb-[3px]',
      'items-center',
      '[&_span]:text-components-pagination-on-white-text-default',
    ],
    paginationPage: [
      'flex',
      'py-components-button-spacing-compressed-default-padding-y',
      'px-components-button-spacing-compressed-default-padding-x',
      'rounded-themes-spacing-radius-large-button-icon',
      'font-bodySans-medium-semibold',
      'text-bodySans-medium-semibold',
      'leading-bodySans-medium-semibold',
      'text-components-pagination-on-white-text-default',
    ],
    paginationDisplayPage: [
      'flex-row',
      'justify-center',
      'font-bodySans-medium-semibold',
      'text-bodySans-medium-semibold',
      'leading-bodySans-medium-semibold',
      'md:font-bodySans-small',
      'md:text-bodySans-small',
      'md:leading-bodySans-small',
      'text-components-pagination-on-white-text-default',
    ],
    paginationGroup: ['flex-col', 'items-center', 'gap-spacing-spacing-5', 'flex'],
  },
  variants: {
    isMobile: {
      true: {
        paginationDisplayPage: ['md:hidden', 'flex'],
      },
      false: {
        paginationDisplayPage: ['hidden', 'md:flex'],
      },
    },
    currentPage: {
      true: {
        paginationPage: [
          'bg-components-pagination-on-white-bg-active',
          '!text-components-pagination-on-white-text-active',
        ],
      },
      false: {
        paginationPage: [
          'hover:bg-components-pagination-on-white-bg-hover',
          'hover:text-components-pagination-on-white-text-hover',
        ],
      },
    },
  },
});

export const tailwindMain = tv({
  slots: {
    mainContainer: [
      'product-card-listing',
      'px-themes-general-surface-spacing-small-padding-x',
      'py-themes-general-surface-spacing-small-padding-y',
      'md:px-components-product-results-list-with-search-spacing-large-padding-x',
      'md:py-components-product-results-list-with-search-spacing-large-padding-y',
      'relative',
    ],
    noResultMsgTextclass: [
      'font-bodySans-small',
      'text-bodySans-small',
      'text-themes-color-text-dark',
      'leading-bodySans-small',
      'md:font-bodySans-large',
      'md:text-bodySans-large',
      'md:leading-bodySans-large',
    ],
  },
});
